import { type MasonryEngineActionHandler } from '@leagueplatform/masonry-engine';
import {
  MasonryDriverAction,
  type MasonrySetTitleAction,
} from '@leagueplatform/masonry-renderers';

/**
 * Action handler for the `setTitle` action. Formats the title from the
 * action payload using the `DOCUMENT_TITLE` intl translation key and sets
 * the result as the document title.
 */
export const masonrySetTitleBaseActionHandler: MasonryEngineActionHandler<
  MasonrySetTitleAction,
  MasonryDriverAction
> = ({ payload: { title } }, { intl }) => {
  if (typeof window !== 'undefined') {
    window.document.title = intl.formatMessage(
      { id: 'DOCUMENT_TITLE' },
      { title },
    );
  }
};
